import type {IHttpError} from "@/interfaces/http.interface";
import {useAuthStore} from "@/store/authStore";

export const manageCatchError = (err: IHttpError) => {
  const {status, message} = err;

  if (status === 500) {
    throw new Error("internalServerError");
  }
  if (status === 401) {
    useAuthStore.getState().logout();
    throw new Error("sessionExpired");
  }
  if (status === 403) {
    useAuthStore.getState().logout();
    throw new Error("forbidden");
  }

  throw new Error(message);
};
